// Default currencies template for new offices
export const defaultCurrencies = [
  {
    flag: 'us',
    nameEn: 'US Dollar',
    nameAr: 'دولار أمريكي',
    iso: 'USD',
    units: '1',
    buy: 118.5,
    sell: 119,
    order: 0,
  },
  {
    flag: 'gb',
    nameEn: 'British Pound',
    nameAr: 'جنيه إسترليني',
    iso: 'GBP',
    units: '1',
    buy: 150,
    sell: 154,
    order: 1,
  },
  {
    flag: 'eu',
    nameEn: 'European Euro',
    nameAr: 'يورو أوروبي',
    iso: 'EUR',
    units: '1',
    buy: 128,
    sell: 129,
    order: 2,
  },
  {
    flag: 'sa',
    nameEn: 'Saudi Riyal',
    nameAr: 'ريال سعودي',
    iso: 'SAR',
    units: '1',
    buy: 29,
    sell: 30,
    order: 3,
  },
  {
    flag: 'kw',
    nameEn: 'Kuwaiti Dinar',
    nameAr: 'دينار كويتي',
    iso: 'KWD',
    units: '1',
    buy: 365,
    sell: 373,
    order: 4,
  },
  
  {
    flag: 'tr',
    nameEn: 'Turkish Lira',
    nameAr: 'ليرة تركية',
    iso: 'TRY',
    units: '1',
    buy: 252,
    sell:262  ,
    order: 6,
  },
  {
    flag: 'ae',
    nameEn: 'UAE Dirham',
    nameAr: 'درهم إماراتي',
    iso: 'AED',
    units: '1',
    buy: 30,
    sell: 31,
    order: 7,
  },
];
